var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add-edit-credit-card-dialog',{attrs:{"show-dialog":_vm.showDialog,"is-new-card":true,"submitted":_vm.submitted,"cc-token":_vm.ccToken},on:{"update:submitted":function($event){_vm.submitted=$event},"submitted":_vm.addCard,"edited":_vm.editCard,"confirm-removal":_vm.confirmRemoval,"close-dialog":_vm.closeDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }